import { useEvolucoesProblemaModalLazyQuery } from 'graphql/hooks.generated'
import React, { useMemo, useState } from 'react'
import { Problema } from 'view/atendimentos/detail/soap/aside/types/ProblemaModel'

import convertEvolucaoProblemaToModel from '../../../soap/aside/lista-problemas/convertEvolucaoProblemaToModel'
import { MainDetailAccordion } from '../../MainDetailAccordion'
import { BodyProblemaModal } from './BodyProblemaModal'
import { HeaderProblemaModal } from './HeaderProblemaModal'

interface AccordionProblemasModalProps {
  problemas: Problema[]
  dataNascimentoCidadao: LocalDate
  filtro?: string
}

export function AccordionProblemasModal(props: AccordionProblemasModalProps) {
  const { problemas, dataNascimentoCidadao, filtro } = props
  const [problemaLoadingEvolucoesId, setProblemaLoadingEvolucoesId] = useState<string>()

  const [executeQuery, { data, loading }] = useEvolucoesProblemaModalLazyQuery({
    fetchPolicy: 'cache-and-network',
  })

  const problemaQueryResult = !isNaN(+problemaLoadingEvolucoesId) ? data?.problema : null

  const handleProblemaClick = (problemaUUID: string[]) => {
    const problemaId = problemaUUID?.join()
    if (!!problemaId) {
      setProblemaLoadingEvolucoesId(problemaId)
      !isNaN(+problemaId) && executeQuery({ variables: { problemaId: problemaId } })
    }
  }

  const evolucoes = useMemo(() => {
    const problemaEvolucoesLoading = problemas.find((problema) => problema.id === problemaLoadingEvolucoesId)

    return [
      ...(problemaEvolucoesLoading?.evolucoes?.map((evo) => ({
        ...evo,
        possuiCiap: !!problemaEvolucoesLoading.ciap,
        possuiCid: !!problemaEvolucoesLoading.cid10,
      })) ?? []),
      ...(problemaQueryResult?.evolucoes.map((evo) => convertEvolucaoProblemaToModel(evo)) ?? []),
    ]
  }, [problemaLoadingEvolucoesId, problemaQueryResult, problemas])

  return (
    <MainDetailAccordion
      type='problema'
      loading={loading}
      listOf={problemas}
      evolucoes={evolucoes}
      header={<HeaderProblemaModal dataNascimentoCidadao={dataNascimentoCidadao} highlight={filtro} />}
      body={<BodyProblemaModal />}
      onChange={handleProblemaClick}
    />
  )
}
